import { requestPayload, apiEndpoint } from '../utils/common';
import { API } from '../constant';
import { post } from '../utils/http';

/**
 *  Promo offers available on card,wallet and net banking
 *
 * @param {string} cn - Card number or Saved card id
 * @param {string} cardType - DEBIT_CARD,CREDIT_CARD,NET_BANKING,BALANCE
 * @param {boolean} isSC - true if saved card id is provided otherwise set to null
 * @param {string} bankCode - Bank code if cardType is NET_BANKING otherwise set to null
 * @returns {Promise<Object>} - Promise object
 */
export function promoDetails(cn, cardType, isSC, bankCode) {
  const payload = { txnType: cardType };
  let cardNumber = cn;
  if (cardNumber || bankCode) {
    if (isSC) {
      cardNumber += '|';
    }
    if (bankCode) {
      // NB
      payload.bankCode = bankCode;
    } else {
      // Card
      payload.cardNumber = cardNumber;
    }
  }
  return post.call(this, apiEndpoint(API.PROMO), requestPayload(payload));
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/api/promo.js